import PropTypes from "prop-types";
import { useRef } from "react";
import { Button, Dropdown, Form, Image } from "react-bootstrap";
import { ExcelIcon } from "../data/iconImage";
import { ExportExcelFile, ReadExcelFile } from "../commons/FileHandler";

const ExcelFileHandler = ({ data, columns, onReadFileCallback }) => {
  const fileInputRef = useRef(null);

  return (
    <>
      <Dropdown>
        <Dropdown.Toggle
          variant="outline-success"
          className="px-3 py-2 text-dark border-secondary rounded-pill"
        >
          <Image className="me-2" src={ExcelIcon} alt="Excel Icon" />
          จัดการไฟล์ Excel
        </Dropdown.Toggle>

        <Dropdown.Menu className="w-100 p-0 rounded-0 border-0">
          <Dropdown.Item
            className="p-2"
            onClick={() => fileInputRef.current.click()}
          >
            <Dropdown.ItemText className="p-1">
              นำเข้าไฟล์ .xlsx
            </Dropdown.ItemText>
          </Dropdown.Item>

          <Dropdown.Item
            className="p-2"
            onClick={() => ExportExcelFile({ data: data, columns: columns })}
          >
            <Dropdown.ItemText className="p-1">
              ส่งออกไฟล์ .xlsx
            </Dropdown.ItemText>
          </Dropdown.Item>
        </Dropdown.Menu>
      </Dropdown>

      <Form.Control
        ref={fileInputRef}
        type="file"
        className="d-none"
        accept="application/vnd.ms-excel"
        onChange={(e) => onReadFileCallback(ReadExcelFile(e.target.files[0]))}
      />
    </>
  );
};

const ImportExcelButton = ({ name, className, onReadFileCallback }) => {
  const fileInputRef = useRef(null);

  return (
    <>
      <Button
        variant="success"
        className={`${className} px-3 py-2 text-dark rounded-pill`}
        onClick={() => fileInputRef.current.click()}
      >
        <Image className="me-2" src={ExcelIcon} alt="Excel Icon" />
        {name && name}
      </Button>

      <Form.Control
        ref={fileInputRef}
        type="file"
        className="d-none"
        accept=".xlsx, .xls"
        onChange={({ target }) => {
          ReadExcelFile(target.files[0], (read) => onReadFileCallback(read));
          target.value = null;
        }}
      />
    </>
  );
};

ExcelFileHandler.propTypes = {
  data: PropTypes.array,
  columns: PropTypes.array,
  onReadFileCallback: PropTypes.func
};

ImportExcelButton.propTypes = {
  name: PropTypes.string,
  className: PropTypes.string,
  onReadFileCallback: PropTypes.func
};

export { ExcelFileHandler, ImportExcelButton };
